import { batchPrintStepsType } from "../../../../customTypes/batchPrintModal";

export function defineModalTitle(batchPrintSteps: batchPrintStepsType) {
    const title = batchPrintSteps.stepA_Confirm
        ? "STEP 1: CONFIRM SELECTION"
        : batchPrintSteps.stepB_PreparePdf
            ? "STEP 2: PREPARING PDF DOCUMENT..."
            : batchPrintSteps.stepC_DocumentReady
                ? "STEP 2: PDF DOCUMENT READY"
                : batchPrintSteps.stepD_Confirm
                    ? "STEP 3: CONFIRM DOCUMENTS HAVE PRINTED"
                    : batchPrintSteps.pdfGenError
                        ? "Compilation Error"
                        : batchPrintSteps.docExpired
                            ? "PDF DOCUMENT EXPIRED"
                            : batchPrintSteps.cancelConfirmPrint || batchPrintSteps.cancelConfirmError
                                ? "ARE YOU SURE YOU WANT TO CANCEL?"
                                : batchPrintSteps.confirmingPrintJobs
                                    ? "CONFIRMING BATCH PRINT JOB"
                                    : ""

    return title;
}